import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import { useDispatch, useSelector } from 'react-redux'
import { Typography, Grid, useTheme, } from '@mui/material'
import Parser from 'html-react-parser';
import { AddCircle, RemoveCircle, HelpRounded } from '@mui/icons-material';

import { creditActions, workflowActions } from '../../store/actions'//Acciones para redux
import { useStyles } from './OfertaCreditoFormStyles'//Estílos específicos de los elementos de este componente
import { coreFunctions } from '../../utils'//funciones del nucleo
import { GenericContainer, CustomAlertMaterial, CustomAlertHelpDialog, CustomLoadingOverlay, Buttons } from '../../components'
import { useTranslation } from 'react-i18next';

const formatterDolar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
})

export default function OfertaCreditoFormComponent(props) {
    const { useState, useEffect } = React//Hook para el state    
    const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader    
    const [stateActualActivo, setStateActualActivo] = useState(false)
    const [cancelAction, setCancelAction] = useState(false)
    const [continueAction, setContinueAction] = useState(false)
    const location = useLocation()
    const classes = {} //mainStyles.bodyStyles()//estílos genéricos (Main.js)
    const localStyles = {}//useStyles()//estílos de este componente (LoginStyles.js)
    const navigate = useNavigate()//Módulo "History" de react router

    //Estados de componente
    const [textButton, setButtonData] = useState('')
    const [performLogout, setPerformLogout] = useState(0)
    const [allowCancelFlow, setAllowCancelFlow] = useState(0)
    const [goToDashboard, setGoToDashboard] = useState(0)
    const [showAlertMaterial, setShowAlertMaterial] = useState(false)
    const [open, setOpen] = useState(false);

    const [fileId, setFileId] = useState(0)
    const [fileCode, setFileCode] = useState('')
    const [monto, setMonto] = useState(0)
    const [plazo, setPlazo] = useState(0)
    const [descuento, setDescuento] = useState(0)
    const [tasaMensual, setTasaMensual] = useState(0)
    const [tasa, setTasa] = useState(0)
    const [cat, setCat] = useState(0)
    const [user, setUser] = useState('')
    const [telefono, setTelefono] = useState('')


    //Redux hooks
    const credit = useSelector(state => state.CreditOption)
    const file = useSelector(state => state.FileInfo)
    const asigCreditOption = useSelector(state => state.AsignateCreditOption)
    const cancelWF = useSelector(state => state.CancelWorkFlow)

    // const notification = useSelector(state => state.ReSendNip)
    const dispatch = useDispatch()
    const { t } = useTranslation();

    /*Comienzan métodos y escuchas de componente**/
    //Promesa general Init
    useEffect(() => {
        // interval = setInterval(() => tick(), 30000);
        if (stateActualActivo == false) {
            setFileId(location.state.folioId)
            dispatch(creditActions.GetNewCreditOption(location.state.folioId))
            setStateActualActivo(true)
        }
    }, [])

    //Obtener valores de persistencia de datos y mostrarlos en interfaz
    useEffect(() => {
        //Se cachan parámetros de salida en UI desde persistencia de datos, nombre, correo y teléfono
        if (file.items != undefined) {
            // console.log('FileInfo', file.items)
            setFileCode(file.items.Folio)
            setUser(file.items.FullName)
            setTelefono(file.items.PhoneNumber)

            let performLogout = file.items.Stage.Properties.find(element => element.Name == "PerformLogout")
            let allowCancelFlow = file.items.Stage.Properties.find(element => element.Name == "AllowCancelFlow")
            let goToDashboard = file.items.Stage.Properties.find(element => element.Name == "GoToDashboard")

            setPerformLogout(performLogout?.Value)
            setAllowCancelFlow(allowCancelFlow?.Value)
            setGoToDashboard(goToDashboard?.Value)
        }
    }, [file])

    //Obtener valores de persistencia de datos y mostrarlos en interfaz
    useEffect(() => {
        //Se cachan parámetros de salida en UI desde persistencia de datos, nombre, correo y teléfono
        if (credit.items != undefined) {
            // console.log('Credit ', credit.items)
            setMonto(formatterDolar.format(credit.items.Amount))
            setPlazo(credit.items.Term)
            setDescuento(formatterDolar.format(credit.items.Discount))
            setTasaMensual(credit.items.MonthlyRate.toFixed(2))
            setTasa(credit.items.AnnualRate.toFixed(2))
            setCat(credit.items.CAT.toFixed(2))
        }
    }, [credit])

    useEffect(() => {
        if (asigCreditOption.items != undefined && continueAction) {
            // console.log('asigCreditOption ', asigCreditOption.items)

            let nextStage = asigCreditOption.items.Stage
            let stageName = nextStage.Name
            let stageId = nextStage.Id
            let folioId = fileId
            let stage = asigCreditOption.items

            let nextComponent = coreFunctions.GetLegoNext(stageName)
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })

            // let nextStage = asigCreditOption.items.Stage
            // let stageName = nextStage.Name
            // let stageId = nextStage.Id
            // let stage = asigCreditOption.items
            // let nextComponent = coreFunctions.GetLegoNext(stageName)
            // OfertaCreditoFormFunctions.doNextStage({ auth ,navigate,nextComponent, stageName, stageId, stage })
        } else if (asigCreditOption.error != undefined && asigCreditOption.error != null
            && asigCreditOption.error && continueAction) {
            alert('Error: ' + asigCreditOption.error)
        }
    }, [asigCreditOption])

    useEffect(() => {
        if (cancelWF.items != undefined && cancelAction) {
            // console.log('cancelWF: ', cancelWF.items)
            if (goToDashboard == 1) {
                //TODO: Se implementa cuando exista dashboard
                // navigate('/')
            } else if (performLogout == 1) {
                navigate('/')
            } else {
                navigate('/')
            }
        }
    }, [cancelWF])


    //Método controlador de reenvió de pin o edición de datos
    let handleContinue = () => {
        setContinueAction(true)
        dispatch(creditActions.AsignateNewCreditOption(fileId))
    }

    let handleCancel = () => {
        setShowAlertMaterial(true)
    }

    let handleAlerDialog = (pos) => {
        switch (pos) {
            case 'left':
                setShowAlertMaterial(false)
                console.log('Cancela modal')
                break;
            case 'right':
                setCancelAction(true)
                dispatch(workflowActions.CancelWorkFlow({ File_Id: file.items.Id }))
                break;
            default:
                break;
        }
        setShowAlertMaterial(false)
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    //Comienza interfaz
    return (<GenericContainer>
        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}

        <Typography
            variant="h6"
            gutterBottom
            
          >Nueva oferta de crédito
            <HelpRounded
                className={localStyles.helpIcon}
                onClick={handleClickOpen}
            />
        </Typography>
        <Typography variant="subtitle1"
            gutterBottom
            className={localStyles.title}>Solicitante:</Typography>
        <Typography variant="subtitle1"
            gutterBottom
             >{user}</Typography>

        <div className={localStyles.containerResult}>
            <div className={localStyles.leftColumnResult}>
                <Typography variant="subtitle1" gutterBottom className={localStyles.title}>Folio:</Typography>
                <Typography variant="subtitle1" gutterBottom  >{fileCode}</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.title}>Monto:</Typography>
                <Typography variant="subtitle1" gutterBottom  >{monto}</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.title}>Descuento:</Typography>
                <Typography variant="subtitle1" gutterBottom  >{descuento}</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.title}>Tasa:</Typography>
                <Typography variant="subtitle1" gutterBottom  >{tasa} %</Typography>
            </div>
            <div className={localStyles.rightColumnResult}>
                <Typography variant="subtitle1" gutterBottom className={localStyles.title}>Teléfono:</Typography>
                <Typography variant="subtitle1" gutterBottom  >{telefono}</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.title}>Plazo:</Typography>
                <Typography variant="subtitle1" gutterBottom  >{plazo} meses</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.title}>Tasa mensual:</Typography>
                <Typography variant="subtitle1" gutterBottom  >{tasaMensual} %</Typography>
                <Typography variant="subtitle1" gutterBottom className={localStyles.title}>CAT:</Typography>
                <Typography variant="subtitle1" gutterBottom  >{cat} %</Typography>
            </div>
        </div>

        <Buttons
            onClickConfirm={handleContinue}
            onClickCancel={allowCancelFlow == 1 ? handleCancel() : undefined}
            CancelButtonText="Rechazar" />

        <CustomAlertMaterial
            title='Oferta rechazada'
            body='Al rechazar la nueva oferta de crédito, deberás comenzar el proceso para una nueva solicitud. ¿Estas seguro de rechazar la oferta de crédito?'
            leftButtonText={t("general_cancel")}
            closeAction={() => setShowAlertMaterial(false)}
            open={showAlertMaterial}
            leftButtonAction={() => handleAlerDialog('left')}
            rightButtonText={t("general_accept")}
            rightButtonAction={() => handleAlerDialog('right')}
        />

        <CustomAlertHelpDialog open={open}
            closeAction={handleClose}
            title="¿Cómo se calculan las comisiones?"
            body={
                <div>
                    <Typography gutterBottom className={localStyles.instructions} >Tasa anual.</Typography>
                    <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>{Parser("Es la tasa que se cobra por los préstamos o las ganancias obtenidas a través de una inversión, y se expresa como un porcentaje que representa el costo anual real de los fondos durante el plazo de un préstamo. <br> Esto incluye cualquier cargo o costo adicional asociado con la transacción pero no toma en cuenta la capitalización.")}</Typography>
                    <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>¿Cómo se calcula la Tasa Anual de un préstamo?</Typography>
                    <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>{Parser("Para calcular la tasa efectiva anual de un préstamo es necesario conocer el valor neto del préstamo solicitado, la tasa de interés establecida por la entidad financiera o prestamista y el plazo en que el mismo debe ser cancelado <br> Una vez determinadas estas tres variables, se utiliza una fórmula para determinar el valor de cada cuota mensual. <br> Sería: EAR = 1 + inn –1EAR = Tasa de interés efectiva anuali = Tasa de interés nominaln = cantidad de pagos consecutivos cancelados en un añoPasos para calcular la tasa efectiva anual de un préstamo.")}</Typography>
                    <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>1.En primer lugar se divide la tasa de interés nominal entre 100 para convertirlo en número natural.</Typography>
                    <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>2.Entonces se divide el resultado entre la cantidad de pagos a realizar en el año, es decir, si es pago mensual seríandividido entre 12, si es pago semestral sería dividido entre 2, etc.</Typography>
                    <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>3.Se le suma una unidad al resultado (+1)</Typography>
                    <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>4.El resultado se eleva a la potencia de n (pagos a realizar anualmente).</Typography>
                    <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>{Parser("5. Por último se resta una unidad (-1) y este será el valor de latasa efectiva de interés anual de un préstamo.<br>Ejemplo:<br> 1.Tenemos una tasa de interés nominal del 15% (15/100 = 0,15), cuyo préstamo debe ser pagado en cuotas trimestrales.")}</Typography>
                    <Typography variant="subtitle1" gutterBottom className={localStyles.instructions}>2.EAR = 0,15/4 (número de trimestres en el año) = 0,0375 + 1 = 1,03753. EAR = 1,0375^4 = 1,1586 –1 = 0,1586</Typography>
                </div>
            }
        />
    </GenericContainer>)
}
